import Footer from '../components/Footer';

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-csgo-bg pt-24 md:pt-32 pb-16">
      <div className="fixed inset-0 bg-grid opacity-20 pointer-events-none" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="font-orbitron font-black text-4xl md:text-5xl text-white mb-4">
            Cookie <span className="text-csgo-primary">Policy</span>
          </h1>
          <p className="font-rajdhani text-csgo-textMuted">
            Last updated: January 2026
          </p>
        </div>

        <div className="bg-csgo-surface/60 border border-csgo-border rounded-xl p-6 md:p-8 space-y-8">
          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">1. What Are Cookies?</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              Cookies are small text files that are stored on your device when you visit a website. They help websites remember your preferences and improve your browsing experience.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">2. How We Use Cookies</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed mb-4">
              We use cookies for the following purposes:
            </p>
            <ul className="font-rajdhani text-csgo-textMuted space-y-2 list-disc list-inside">
              <li><strong className="text-white">Essential Cookies:</strong> Required for the website to function properly</li>
              <li><strong className="text-white">Analytics Cookies:</strong> Help us understand how visitors use our website</li>
              <li><strong className="text-white">Preference Cookies:</strong> Remember your settings and preferences</li>
              <li><strong className="text-white">Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
            </ul>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">3. Types of Cookies We Use</h2>
            <div className="overflow-x-auto">
              <table className="w-full font-rajdhani">
                <thead>
                  <tr className="border-b border-csgo-border">
                    <th className="text-left py-3 text-white">Cookie Type</th>
                    <th className="text-left py-3 text-white">Purpose</th>
                    <th className="text-left py-3 text-white">Duration</th>
                  </tr>
                </thead>
                <tbody className="text-csgo-textMuted">
                  <tr className="border-b border-csgo-border/50">
                    <td className="py-3">Session</td>
                    <td className="py-3">Essential functionality</td>
                    <td className="py-3">Browser session</td>
                  </tr>
                  <tr className="border-b border-csgo-border/50">
                    <td className="py-3">Analytics</td>
                    <td className="py-3">Traffic analysis</td>
                    <td className="py-3">Up to 2 years</td>
                  </tr>
                  <tr className="border-b border-csgo-border/50">
                    <td className="py-3">Preferences</td>
                    <td className="py-3">User settings</td>
                    <td className="py-3">1 year</td>
                  </tr>
                  <tr>
                    <td className="py-3">Affiliate</td>
                    <td className="py-3">Referral tracking</td>
                    <td className="py-3">30 days</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">4. Third-Party Cookies</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              Some cookies on our website are set by third-party services. These may include analytics providers and advertising networks. We do not control these cookies and recommend reviewing their privacy policies.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">5. Managing Cookies</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed mb-4">
              You can control and manage cookies in several ways:
            </p>
            <ul className="font-rajdhani text-csgo-textMuted space-y-2 list-disc list-inside">
              <li>Browser settings: Most browsers allow you to block or delete cookies</li>
              <li>Private browsing: Use incognito/private mode to prevent cookies from being stored</li>
              <li>Cookie management tools: Various browser extensions can help manage cookies</li>
            </ul>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed mt-4">
              Note: Disabling certain cookies may affect the functionality of our website.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">6. Browser-Specific Instructions</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed mb-4">
              To manage cookies in your browser:
            </p>
            <ul className="font-rajdhani text-csgo-textMuted space-y-2 list-disc list-inside">
              <li><strong className="text-white">Chrome:</strong> Settings → Privacy and Security → Cookies</li>
              <li><strong className="text-white">Firefox:</strong> Settings → Privacy & Security → Cookies</li>
              <li><strong className="text-white">Safari:</strong> Preferences → Privacy → Cookies</li>
              <li><strong className="text-white">Edge:</strong> Settings → Privacy → Cookies</li>
            </ul>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">7. Updates to This Policy</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              We may update this Cookie Policy periodically. Changes will be posted on this page with an updated revision date. Continued use of our website after changes constitutes acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h2 className="font-orbitron font-bold text-xl text-white mb-4">8. Contact</h2>
            <p className="font-rajdhani text-csgo-textMuted leading-relaxed">
              If you have questions about our use of cookies, please refer to our <a href="/privacy-policy" className="text-csgo-primary hover:underline">Privacy Policy</a> or contact us through the appropriate channels.
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <p className="font-rajdhani text-sm text-csgo-textMuted">
            This is an affiliate website. We are not affiliated with CSGOLuck or Valve Corporation.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CookiePolicy;
